import Vue from "vue";

export const regionsService = {
  retrieveStates,
  retrieveRegions
};

function retrieveStates(params) {
  return Vue.axios.get("/v1/public/states", { params });
}

function retrieveRegions(params) {
  return Vue.axios.get(`/v1/public/states/${params.stateId}/cities`);
}
